export const words = [
    {
      word: "Anar",
      explanation:
        "Tavaratalo Kärkkäisen myymä hyvälaatuinen teltta, erityisesti pressan suosiossa.",
    },
    {
      word: "Aurusaun",
      explanation:
        "Höyrysauna, kokoontumisajojen klassikko ja huonossa tapauksessa viikonlopun ainoa lämmin ja kuiva hetki.",
    },
    {
      word: "Buutsimies",
      explanation:
        "Virolainen motoristi, joka sammui telttaansa niin että jalat ajokenkineen jäivät teltan ulkopuolelle. Buutsimiehen vaimo ei oikein tykännyt tästä.",
    },
    {
      word: "Convoy",
      explanation:
        "Letka-ajo, epäonnistuu yleensä joko jäsenistön omasta suorittamisesta tai ulkopuolisesta häiriötekijästä, esim. liikennevalot tai poliisi.",
    },
    {
      word: "Founder",
      explanation: "Alkuperäinen perustajäsen vuoden 2000 aloituksesta.",
    },
    { word: "Hotelli", explanation: "Kokoontumisajojen sisämajoitus" },
    {
      word: "Hotellihomo",
      explanation:
        "Sisämajoitukseen nolosti turvautunut klubilainen, vastakohta outdoorille.",
    },
    {
      word: "Intikka",
      explanation:
        "Suzuki Intruder, moottoripyörien aatelia ja 1800-kuutioisena koko harrastuksen korkein aste.",
    },
    {
      word: "Josimurra",
      explanation:
        "Pressan aikoinaan Suzuki DR 800:n sovittama äänenvaimennin. Kapistus oli dyykattu roskakuormasta jonne se oli päätynyt työkaverin Citroen Xsaran alta.",
    },
    {
      word: "Jute",
      explanation:
        "Mp-mekaanikko, jota eräs pitkäaikainen jäsenemme käyttää aina motskarinsa huoltamiseen. Kukaan muu ei ole koskaan nähnyt Jutea, joten kyseessä on melko mystinen kaveri.",
    },
    {
      word: "Jäätelömyyjä",
      explanation:
        "Moottoripyöräpoliisi valkoisine sivulaukkuineen. Tämä jäätelö kannattaa jättää väliin, kallista lystiä.",
    },
    {
      word: "Kiinalainen kopio-Akra",
      explanation:
        "Jonin edellisessä pyörässä ollut postimyynnistä tilattu ”äänenvaimennin”, aivan karmea mökäpönttö joka todennäköisesti vain vahvisti kaikkia saatavilla olevia ääniä.",
    },
    {
      word: "Kilu",
      explanation:
        "Kilohaili, virolainen kansanherkku. Kiluleipä maistuu osalle ja toisten mielestä se olisi parhaimmillaan kaatopaikalla. Reilusti suolaisena optimaalinen valinta kännätyn illan jälkeiselle aamupalalle.",
    },
    {
      word: "Kärkkainen",
      explanation:
        "Tavaratalo Lahdessa, hyvä paikka tehdä löytöjä leirintävarustukseen.",
    },
    {
      word: "Kiirabi",
      explanation:
        "Virolainen ambulanssi, kovasti työllistetty kuljettaessaan raatoja pikavuorolla Jögeva- Tarto – Jögeva. Virossa ei suljetulla alueella kännissä keulimista pidetä sen kummenpana rikkeenä, Darwin ottaa toki omansa ja kiirabi loput.",
    },
    { word: "Munakuppi", explanation: "Höyrysaunan istuinpaikka." },
    { word: "Nappikorva", explanation: "Leirintäalueen järjestyksenvalvoja." },
    {
      word: "Narut poikki",
      explanation:
        "Teltan tms. leirintävarusteiden hylkääminen kokoontumisajoihin.",
    },
    {
      word: "Outdoor",
      explanation:
        "Kerhon alajaosto, majoittuu kokoontumisissa telttaan ilman poikkeuksia.",
    },
    {
      word: "Pannut",
      explanation:
        "Moottoripyörällä suoritettu tahaton kaatuminen, ts. lipat. Johtuu yleensä hieman liian kovasta tilannenopeudesta.",
    },
    {
      word: "Pasuuna",
      explanation:
        "Suzuki Banditin isokokoinen vakioäänenvaimennin, vaihtamalla tämän tarvikkeeseen saadaan helposti jopa 20 kilon painonsäästö.",
    },
    {
      word: "Paugutus",
      explanation:
        "Virolainen kansanhuvi, moottorin huudattaminen korkeilla kierroksilla ja sytysvirran katkominen sammutinnapilla saa moottorin paukkumaan ja iskemään liekkejä pakoputkesta.",
    },
    {
      word: "Porkkala",
      explanation:
        "Legendaarinen mutkapätkä Kirkkonummella, tielaitoksen rakentama kaikille avoin kilparata. Ainoastaan ajanotto puuttuu.",
    },
    {
      word: "Progu",
      explanation: "Kokelasjäsen jolla ei vielä oikeutta selkämerkkiin.",
    },
    {word: "Queen bee", explanation: "Mehiläiskuningatar; Kerhon presidentin vaimo, jolle pitää olla kiva tai päälikkö suuttuu"},
    {
      word: "Rannarootsi",
      explanation:
        "Virolainen makkara ja kerhon virallinen eväs kaikkeen grillaamiseen. Tarjoillaan nenäontelot puhdistavan Pöltsamaa Kange sinapin kera.",
    },
    {
      word: "Rintteri",
      explanation:
        "Kerhon epävirallinen huoltoauto, noin 600 tkm ajettu Mercedes-Benz Sprinter. Pressan omistuksessa, tapahtumissa ajaminen jää progujen hommiksi.",
    },
    {
      word: "Rosvo",
      explanation:
        "Suzuki Bandit, hyvämaineinen katupyörä. Loistava valinta nuorelle miehelle, miksei myös naiselle. Saatavilla sekä 650- että 1250-kuutioisena versiona, pienempi ei välttämättä ole hitaampi tai ainakaan vähemmän äänekäs.",
    },
    {
      word: "Rättimummo",
      explanation:
        "Kokoontumisajojen virolainen vanhempi nainen, joka siivosi vessoja rätillä pyyhkimällä. Rätin väri tummui joka pyyhkäisyn jälkeen, mutta rättiä ei turhaan vaihdettu.",
    },
    {
      word: "Selitys",
      explanation:
        "Virolaiselle miliisille vähintään kolmella kielellä annettu selonteko tikkaria reilusti kovemmasta nopeudesta.",
    },
    {
      word: "Simo",
      explanation:
        "Hylätyillä leirintävarusteilla täytetty rikkinäinen makuupussi joka jätettiin aikoinaan jögevatreffin leirintäalueelle. Simoa muistellaan joka vuosi ja otetaan huikat.",
    },
    {
      word: "Tikkari",
      explanation:
        "Nopeusrajoitusmerkki tiellä, jotkut ovat todistetusti ajaneet kovempaakin.",
    },
    {
      word: "Tint",
      explanation:
        "Virolainen kuivattu pikkukala. Aivan kammottavan makuinen eväs, parhaimmillaan ammuttuna hyvin virtaavasta Gixerin äänenvaimentimesta norjalaisten motoristien telttaan.",
    },
    {
      word: "Toitoi",
      explanation:
        "Jögevassa käytössä ollut käymälä eli ”bajamaja”, viimeistään toisena päivänä niin täynnä tavaraa että ylimmät roiskeet kurkkaavat kannesta yli. Väinö Linnaa lainaten, ”Jeesus, kuinka tuolla voi ihminen olla?”Moni kovana pidetty kaveri tyytyi vain kusemaan ulostevelliin, muu sai muuttua lihaksi",
    },
    {
      word: "Tohtori",
      explanation:
        "Suzuki DR, yksisylinterinen iso enduro, jolla on tapana pudotella osia ajon aikana, johtuu moottorin aiheuttamasta tärinästä. Yleensä mitään tärkeämpää ei irtoa.",
    },
    {
      word: "Tuolileikki",
      explanation:
        "Joltain jää aina kokoontumisajojen matkasta kokoontaitettava telttatuoli. Tuolinsa unohtanut yrittää yleensä paikata virheensä ”lainaamalla” jonkun muun tuolia, mistä illan tummuessa ja humalan lisääntyessä seuraa mitä hassumpia tilanteita.",
    },
    { word: "Veturi", explanation: "Honda VTR, kaksisylinterinen katupyörä." },
    { word: "Vice", explanation: "VP eli varapresidentti" },
    {
      word: "Wetter",
      explanation:
        "Jättikokoinen ja hallitseva, suorastaan waltawa kokokate, jonka klubimme pitkäaikainen jäsen on tuunannut Möhkö-Kawaansa. Lopputulos on - ainakin erikoinen.",
    },
    {
      word: "7%",
      explanation:
        "Forecan sääennusteen todennäköisyys sateelle. Käytännössä tällöin sataa paljon ja pitkään.",
    },
  ];